import {styled} from '../../styled-components';

/**
 * Container component for actions at the bottom of Dialog component.
 */
export const DialogActionsStyle = styled.div`
    display: flex;
    flex: 0 0 auto;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: ${props => props.theme.color.primary.light};
    padding: ${props => props.theme.spacing.units(5)};
`;

DialogActionsStyle.displayName = 'DialogActionsStyle';
